import type { ReactNode } from 'react';

import { Sport } from '#src/__generated__/globalTypes.ts';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import type { Item } from '#src/components/link/OpenItemDialogLink/types.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';
import * as nativeMessages from '#src/protos/webview/channel/native_messages.ts';
import type { StringKeysOf } from '#src/types/index.ts';

type messages = StringKeysOf<nativeMessages.ChannelMessage>;

const getCollectionFromSport = (sport?: Sport) => {
  switch (sport) {
    case Sport.NBA:
      return nativeMessages.Collection.NBA;
    case Sport.FOOTBALL:
      return nativeMessages.Collection.FOOTBALL;
    case Sport.BASEBALL:
      return nativeMessages.Collection.BASEBALL;
    default:
      return nativeMessages.Collection.COLLECTION_UNKNOWN;
  }
};
const getItemPostMessage = (
  item: Item
): {
  message: messages;
  params: nativeMessages.ChannelMessage[messages];
} | null => {
  switch (item.__typename) {
    case 'BaseballCard':
    case 'NBACard':
    case 'Card': {
      return {
        message: 'showCardScreen',
        params: {
          cardSlug: item.slug,
          collection: getCollectionFromSport(item?.sport),
        },
      };
    }
    default: {
      return null;
    }
  }
};

type Props = {
  item: Item;
  children?: ReactNode;
};

export const IosOpenItemDialog = ({ item, children }: Props): ReactNode => {
  const { postMessage } = useIsMobileApp();
  const itemPostMessage = getItemPostMessage(item);

  if (!itemPostMessage) return children;

  const { message, params } = itemPostMessage;

  return (
    <ButtonBase
      onClick={() => {
        postMessage(message, params);
      }}
    >
      {children}
    </ButtonBase>
  );
};
